import { createComponent } from '@carvana/merch-components';

export const HeroWrapper = createComponent('section', {
  className: 'relative h-fit w-full bg-grey-1'
});

export const HeroImage = createComponent('div', {
  className:
    'h-[250px] w-full bg-[50%_70%] bg-no-repeat m:h-[400px] m:bg-cover m:bg-[center_70%] xl:bg-[center_60%]'
});

export const Copy = createComponent('div', {
  className: ' whitespace-nowrap tl-brand-s m:tl-brand-l'
});

export const SubCopy = createComponent('span', {
  className: 'mt-8 text-white tl-header-s m:mt-16 m:tl-header-m'
});
